/*
 * Copyright (c) Dito Technologies
 */

export const ORIGIN_PATH = "/";
export const LOGIN_PATH = "/login";
export const ROOT_PATH = "/home";
export const ACCOUNT_PATH = "/account";
export const LIBRARY_PATH = "/library";
export const BACKDOOR_LOGIN = "/backdoor-login";
export const LIBRARY_DETAIL_TEMPLATE = "/library/:piece_id";
export const PIECE_ORIGINAL_IMAGES_TEMPLATE = "/library/:piece_id/piece-original-images";
export const PIECE_SETTINGS_TEMPLATE = "/library/:piece_id/settings";
export const PIECE_EDIT_TEMPLATE = "/library/:piece_id/edit";
export const PIECE_PLAY_TEMPLATE = "/library/:piece_id/play"

export function LibraryDetail(pieceId: string): string {
    return LIBRARY_DETAIL_TEMPLATE.replace(":piece_id", pieceId)
}

export function PieceEdit(pieceId: string): string {
    return PIECE_EDIT_TEMPLATE.replace(":piece_id", pieceId)
}

export function PieceOriginalImages(pieceId: string): string {
    return PIECE_ORIGINAL_IMAGES_TEMPLATE.replace(":piece_id", pieceId);
}

export function PieceSettings(pieceId: string): string {
    return PIECE_SETTINGS_TEMPLATE.replace(":piece_id", pieceId);
}

export function PlayPiece(pieceId: string): string {
    return PIECE_PLAY_TEMPLATE.replace(":piece_id", pieceId);
}

export function PathRequiresAuthentication(p: string): boolean {
    switch (p) {
        case ORIGIN_PATH:
            return false;
        case LOGIN_PATH:
            return false;
        case BACKDOOR_LOGIN:
            return false;
        default:
            return true;
    }
}
